import { useState } from "react";
import axios from "axios";

const PublicationSection = () => {
  const [formData, setFormData] = useState({
    title: "",
    authors: "",
    journalConference: "",
    year: "",
    description: "",
    publishedBy: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://admin.stipsredu.in/publications/add",
        formData
      );

      alert("Publication added successfully!");

      // Reset form
      setFormData({
        title: "",
        authors: "",
        journalConference: "",
        year: "",
        description: "",
        publishedBy: ""
      });

    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Error adding publication");
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Add Publication</h2>

      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded-xl shadow-md">
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="authors"
          placeholder="Authors"
          value={formData.authors}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="journalConference"
          placeholder="Journal/Conference"
          value={formData.journalConference}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="number"
          name="year"
          placeholder="Year"
          value={formData.year}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="publishedBy"
          placeholder="Published By"
          value={formData.publishedBy}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <button
          type="submit"
          className="bg-blue-600 text-white px-6 py-2 rounded-lg"
        >
          Add Publication
        </button>
      </form>
    </div>
  );
};

export default PublicationSection;